<template>
    <div>
        <div class="container-fluid white-bg centers-list">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumbs">
                            <a href="/">Главная</a> / <a href="/home-teacher/onlineteacher">ONLINETeacher</a> /
                            Preschool English 2
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h1 class="strongh1">Preschool English 2. Английский для продолжающих</h1>
                        <p class="px18">Цикл групповых онлайн-занятий по программе «Preschool English 2» разработан
                            специально для детей от 4 до 8 лет, уже имеющих небольшой опыт изучения английского языка.
                            Он является логическим продолжением курса <a
                                    href="https://poliglotiki.com/home-teacher/preschool-english-1">«Preschool English
                                1»</a> и рассчитан на комфортное освоение языка без утомительной зубрёжки.</p>

                        <p class="px18"><span class="strong-black">Пройдя курс, ребёнок добавит к своему словарному запасу <span
                                class="strong-red">750 новых слов</span>, и <span class="strong-red">400 разговорных фраз</span>, научится понимать английскую речь и более уверенно поддерживать диалог на английском языке.</span>
                        </p>


                        <p>&nbsp;</p>
                        <h3 class="redh3" style="text-align: center; margin-bottom: 30px;">Мы изучим:</h3>
                        <div class="indivurok"><div class="urk">школьные принадлежности</div></div>
                        <div class="indivurok"><div class="urk">цвета и формы</div></div>
                        <div class="indivurok"><div class="urk">названия частей тела</div></div>
                        <div class="indivurok"><div class="urk">членов семьи</div></div>
                        <div class="indivurok"><div class="urk">любимые игрушки</div></div>
                        <div class="indivurok"><div class="urk">названия животных</div></div>
                        <div class="indivurok"><div class="urk">названия фруктов и овощей</div></div>
                    </div>
                </div>
            </div>
        </div>
        <!--
        <div class="container-fluid white-bg centers-list razuchim no-shadow">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="skill-wrapper">
                            <div class="skill-text skill-text-1"><span style="word-break: break-all;">школьные принадлежности</span>
                            </div>
                            <div class="skill-text skill-text-2"><span>цвета и формы</span></div>
                            <div class="skill-text skill-text-3"><span>погоду и одежду</span></div>
                            <div class="skill-text skill-text-4"><span>названия частей тела</span></div>
                            <div class="skill-text skill-text-5"><span>членов семьи</span></div>
                            <div class="skill-text skill-text-6"><span>любимые игрушки</span></div>
                            <div class="skill-text skill-text-7"><span>названия животных</span></div>
                            <div class="skill-text skill-text-8"><span>названия фруктов и овощей </span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        -->

        <div class="container-fluid white-bg centers-list no-shadow">
            <div class="container align-middle">
                <div class="row" style="margin-top: 20px;">
                    <div class="col-12">
                        <p class="px18"><span class="strong-green">Растущий словарный запас придаст уверенности вашему ребёнку и вдохновит его на более серьёзное изучение иностранного языка в будущем!</span>
                        </p>
                        <p class="px18">Уроки на платформе OnlineTeacher проводятся профессиональными педагогами в
                            режиме реального времени. Мы обучаем через Интернет, а значит, ваш ребёнок может заниматься
                            где угодно: дома, в машине и даже на даче при помощи обычного смартфона, или планшета. Всё,
                            что вам потребуется, это устойчивая связь (от 1 Mбит/с) и хороший микрофон.</p>
                        <p class="px18"><span class="strong-black">Онлайн-занятия с Полиглотиками - это чудесная возможность интересно и весело провести время, познакомиться с другими детьми, развить навыки общения и подготовиться к школе. Присоединяйтесь к  нашей дружной компании!</span>
                        </p>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                src="https://www.poliglotiki.ru/embed/42MC62cDy00" frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <TimetableStatic id="6444"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h2 class="redh2">Всё о курсе</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-10">
                        <p class="px18"><span class="strong-black">Программа курса «Английский для продолжающих» создавалась методистами Полиглотиков  с учётом новейших открытий в области  нейропедагогики. Цикл занятий выстроен таким образом, что ваш ребёнок может начать обучение в любой момент, и  вам  не придётся догонять группу!</span>
                        </p>
                        <p class="px18">Уроки на нашей онлайн-платформе проходят по расписанию, как и в обычной школе.
                            Из предметов самым важным является <span class="strong-blue">Preschool English 2</span>,
                            мы рекомендуем посещать его не реже 2-3 раз в неделю. К занятиям по остальным предметам
                            &ndash;
                            <span class="strong-blue">Art Class</span>, <span class="strong-blue">Music Class и Story Time</span>
                            можно подключаться от 1 до 5 раз в неделю, исходя из ваших личных симпатий и предпочтений.
                        </p>
                    </div>
                    <div class="col-12 col-sm-2 about-center">
                        <a href="@/assets/hometeacher/images/preschool-english-sertif.jpg" target="_blank"><img
                                src="@/assets/hometeacher/images/preschool-english-sertif-small.jpg"
                                alt="Английский для начинающих" class="sertifikat"></a>
                    </div>

                </div>
                <div class="row">
                    <div class="col-12 col-sm-10">
                        <p class="px18"><span class="strong-black">Курс онлайн-занятий Preschool English 2 разработан специально для детей от 4 до 8 лет
                    с  учётом требований СанПиН. Мы позаботились о том, чтобы ваш малыш не переутомлялся: уроки длятся <span
                                    class="strong-red">от 45 до 60 минут</span>,
                    включая обязательную разминку, гимнастику для глаз и время для обратной связи. В конце  занятия у вас есть <span
                                    class="strong-red">5 минут</span> для того,
                    чтобы обсудить с преподавателем успехи ребёнка и получить рекомендации по самостоятельной работе для закрепления результата.</span>
                        </p>
                        <p class="px18">Наши уроки английского языка настолько увлекательны, что малыши 4-5 лет быстро
                            включаются в образовательный процесс и начинают заниматься самостоятельно, без участия
                            родителей. Вы можете смело доверить ребёнка заботе наших преподавателей: используя смену
                            различных интересных занятий в ходе урока, они мастерски удерживают внимание даже самых
                            маленьких детей.</p>
                    </div>
                    <div class="col-12 col-sm-2 about-center">
                        <a href="@/assets/hometeacher/images/preschool-english-sertif-2.jpg" target="_blank"><img
                                src="@/assets/hometeacher/images/preschool-english-sertif-2-small.jpg"
                                alt="Английский для начинающих" class="sertifikat" style="margin-top:20px;"></a>
                    </div>
                    <!-- <div class="row">
                        <div class="col-12">
                            <CourseStatic id="41"/>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <div class="container-fluid blue-wave-top" style="margin-top: -7px;"></div>
        <div class="container-fluid grey-bg no-shadow" style="text-align:left;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="land-t-h2" style="margin-bottom: 40px; text-align: center;">Наши преподаватели</h2>
                        <p>&nbsp;</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-4 centers-text">
                        <a href=""><img src="@/assets/hometeacher/images/semyonova.jpg" alt="Анастасия Семёнова"
                                        class="teacher-krug"></a>
                        <div class="teacher-name"><a href="" target="_blank">Анастасия Семёнова</a></div>
                        <div class="speach">Hello everyone! Меня зовут Анастасия, я преподаватель центра «Полиглотики».
                            Английский сопровождает меня на протяжении всей жизни с 6 лет. Я влюбилась в этот язык!
                            Особенно мне нравится изучать современный разговорный английский, ведь именно язык и стиль
                            речи быстро меняются с течением времени, и знания по ним постоянно нужно обновлять. 2 года
                            практики ведения занятий в онлайн-формате дали мне огромную базу для проведения интересных и
                            захватывающих занятий с введением интерактива...
                            <!-- Для меня важно заинтересовать ребёнка на уроке, чтобы каждый был вовлечён и погружён в атмосферу!-->
                        </div>
                    </div>
                    <div class="col-12 col-sm-4 centers-text">
                        <a href=""><img src="@/assets/hometeacher/images/rami.jpg" alt="Rami Al-Rasheed"
                                        class="teacher-krug"></a>
                        <div class="teacher-name"><a href="" target="_blank">Rami Al-Rasheed</a></div>
                        <div class="speach">Привет! Я учитель английского и арабского в Полиглотиках. Сейчас изучаю
                            русский язык.
                            Я работал в волонтерской миссии в Сирии и Пакистане, мы обучали детей из маленьких сел
                            английскому языку.
                            В России я уже два года, работаю онлайн с школьниками и дошкольниками. Пою в церковном хоре,
                            занимаюсь благотворительностью.
                            Я люблю детей и хочу научить их всему лучшему, что во мне есть. Мои уроки всегда
                            разнообразные и интересные.
                            Давайте учить английский вместе!
                        </div>
                    </div>
                    <div class="col-12 col-sm-4 centers-text">
                        <a href="https://poliglotiki.com/nicole-cozette.html" target="_blank">
                            <img src="@/assets/hometeacher/images/cozette.jpg" alt="Nicole Cozette"
                                 class="teacher-krug"></a>
                        <div class="teacher-name"><a href="https://poliglotiki.com/nicole-cozette.html" target="_blank">Nicole
                            Cozette</a></div>
                        <div class="speach">In 2015 I graduated high school with a certificate in both first language
                            English and Advanced Subsidiary English.
                            I taught preschool children for a couple years in my home country and really I enjoyed the
                            experience.
                            It was a learning curve for both myself and the children.
                            I rediscovered how eager to learn children are and just how much they can grasp new
                            information.
                            Seeing them progress at tasks and expand their knowledge filled me with such pride and
                            happiness and I felt I had truly added
                            some value to this world. Tecahing really is a big responsibility...
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="container-fluid white-bg centers-list fr-page" style="padding-top: 40px;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="redh2">Как проходят наши уроки</h2>
                        <p class="px18">Особенность онлайн-занятий Полиглотиков &ndash; в активном применении
                            коммуникативного подхода.
                            Иными словами, мы избавим вашего ребёнка от нудной зубрёжки и нагоняющей тоску теории:
                            обучение происходит в процессе общения детей с педагогом, игр, демонстрации предметов и
                            картинок, создания поделок.</p>
                        <p class="px18"><span class="strong-black">В основе наших уроков лежит принцип: «One person – one language». Это означает, что на занятиях педагог общается с детьми только на английском языке, не используя русскую речь для пояснений. Более того, некоторые наши преподаватели являются носителями языка и совсем не говорят по-русски. Таким образом, новый ученик с первого занятия погружается в языковую среду и очень быстро начинает в ней ориентироваться.</span>
                        </p>
                        <p class="px18">Догадаться, о чём говорит преподаватель, ребёнку помогает выразительная мимика,
                            жесты, красочные иллюстрации, которыми сопровождается урок. Новые слова и грамматические
                            конструкции усваиваются на интуитивном уровне, практически без усилий, как при изучении
                            родного языка в раннем детстве. Фактически, у ребёнка формируется билингвизм — в
                            естественных условиях достаточно редкое явление.</p>
                        <p class="px18"><span class="strong-black">Секрет успеха наших занятий в том,  что при обучении детей мы опираемся на законы нейропедагогики &ndash; активно вовлекаем правое полушарие мозга в процесс усвоения иностранного языка. Известно, что правое полушарие отвечает за воображение и эмоции, в то время, как левое &ndash; за логику и и факты.
                    При классическом подходе к обучению возможности правого полушария практически не используются. К счастью, на наших занятиях всё по-другому!</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid blue-wave-top" style="margin-top: -7px;"></div>
        <div class="container-fluid blueback about-fr" style="text-align:left;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="greenh2">Чтобы дети легко запоминали новые слова, наши педагоги:</h2>

                    </div>
                </div>
                <div class="row bird-pres">
                    <div class="col-12 col-sm-3">
                        <img class="" src="@/assets/hometeacher/images/birdushka.png">
                        <p style="margin-top: 25px;">Рисуют вместе с ними и создают поделки</p>
                    </div>

                    <div class="col-12 col-sm-3">
                        <img class="" src="@/assets/hometeacher/images/garant-img-8.png">
                        <p style="margin-top: 25px;">Загадывают им загадки</p>
                    </div>

                    <div class="col-12 col-sm-3">
                        <img class="" src="@/assets/hometeacher/images/bird-8.png">
                        <p style="margin-top: 25px;">Читают вслух книги</p>
                    </div>

                    <div class="col-12 col-sm-3">
                        <img class="" src="@/assets/hometeacher/images/garant-img-5.png">
                        <p>Включают песни и мультфильмы на английском языке</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid white-bg centers-list fr-page" style="padding-top: 40px;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <p class="px18"><span class="strong-red">Вот почему онлайн-занятия от Полиглотиков такие интересные!</span>
                        </p>
                        <p class="px18">Обучение проходит в тёплой позитивной атмосфере. Учёные доказали, что в
                            спокойной обстановке дети воспринимают новую информацию гораздо лучше, поэтому наши
                            специалисты общаются с ними по-дружески, поощряя к развитию. Очень важно, чтобы и родители
                            поддерживали такой стиль общения. Не ругайте ребёнка за ошибки, не подгоняйте его, если
                            прогресс идёт слишком медленно. Лучше похвалите за небольшие успехи.</p>
                        <p class="px18"><span class="strong-black">Очень важно помнить, что наша методика предусматривает постепенное накопление языковых знаний без стресса и напряжения. На первом этапе обучения прогресс может быть мало заметен, и это совершенно нормально. Наберитесь терпения, доверьтесь мастерству наших педагогов и результат не заставит себя ждать!</span>
                        </p>
                        <p class="px18">Авторские программы в Полиглотиках построены таким образом, что заканчивая один
                            курс, учащийся переходит к другому, совершенствуя и улучшая навыки. Курс «Preschool English
                            2» рассчитан на год обучения. Освоив его программу, ваш ребёнок может продолжить обучение на
                            следующей ступени &ndash; <a
                                    href="https://poliglotiki.com/home-teacher/primary-school-english-1">«Primary School
                                English»</a>.</p>

                        <h3 class="redh3" style="text-align: center;">Быть Полиглотиком просто: запишитесь на занятия
                            прямо сейчас и маленькими шагами двигайтесь к большой цели вместе с нами!</h3>
                    </div>
                </div>

                <div class="row about-center">
                    <div class="col-12" style="padding-top: 40px;">
                        <a href="/home-teacher/subscription/order/1/6444" class="knpk">Записаться на курс</a>
                        <p>&nbsp;</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter" style="margin-top: 30px;"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h2><span class="strong-black">Отзывы об онлайн-уроках</span></h2>
                        <p>&nbsp;</p>
                    </div>
                </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/nataliya-yuferova.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">24.05.2021</span>
                  <span class="nameotzyv">Наталия Юферова <a href="https://vk.com/id4037847" target="_blank">vk.com</a></span><br>

                  <span class="textotzyv">Добрый день. Хочу поделиться опытом занятий с Полиглотиками. Присоединились мы осенью 2020 года. Дочке было 5 лет, ранее знакомства с английским языком не было. На Полиглотиков наткнулась случайно: заинтересовал он-лайн формат обучения при многообразии уроков. Я всегда за обучение в формате игр, а тут и music class, и story time, и art class. На первый урок попали к Виктории, с нами были ещё несколько ребят, которые уже ориентировались в английском. Хочу сразу сказать огромное спасибо преподавателям за их чуткость к детям, заинтересованность в их обучении, благожелательность, жизнерадостность и внимание! Спасибо за то, что прививаете любовь к языкам нашим детям! Сразу скажу, что дочка первые занятия не понимала и не запоминала слова, но была увлечена, с нетерпением ждала уроков, и правильный ответ для неё был маленькой победой! Мне в свою очередь было очень удобно он-лайн обучение: мы были на дистанционной работе, а ребёнка можно было просто посадить рядом и подсказывать при необходимости. Сейчас это также удобно, потому что если мы не успеваем, то подключиться к уроку дочка может или сама, или бабушка поможет, не нужно никуда собираться и ехать. А иногда я занимаюсь домашними делами, а ребёнок рядом занимается. При этом мы, родители, знаем, что дети проходят, можем помочь, повторить слова, вводить их в повседневный разговор, скачать изучаемые песни, чтобы вместе попеть, почитать книжку на русском, ту, которую читали на английском на уроках (это просто огромный плюс). А ещё дети неохотно отрываются от своих игр и маленьких дел даже ради любимых занятий, а тут можно даже игрушки не убирать, просто переместиться за стол, а по окончании вернуться в игру. По самим урокам: мне нравится наполненность, дозированность информации в сочетании с переменками в виде песенок с движениями-дети не успевают ни заскучать, ни устать. Поделки с art класса мы носили в садик, дарили в виде новогодних подарков родственникам - темы поделок всегда актуальны. Ещё раз спасибо всем нашим преподавателям! И за обратную связь! Как результат занятий - дочка может пройти этап знакомства, ответить на вопросы о любимых игрушках/блюдах/цветах, рассказать о погоде и описать человека, а ещё спеть пару песенок на английском, но под фонограмму :))) и выдать слова, которые мы вроде не проходили, но встречали на уроках story time. Надеюсь, что дальше будет только увлекательнее и интереснее.</span>

                </div>
              </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/nadya-brandaus.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">21.05.2021</span>
                  <span class="nameotzyv">Nadya Brandaus <a href="https://vk.com/id294529857" target="_blank">vk.com</a></span><br>

                  <span class="textotzyv">Моя дочь семилетка занимается с «Полиглотиками» уже полгода. И каждый раз ждёт новое занятие как праздника. Для меня удивительно, почти час ребёнок погружен в процесс, слушает и отвечает с удовольствием. Преподаватели - просто волшебники! Моя дочь очень застенчива, легко отвлекается, до этого мы пробовали несколько курсов, где не получалось. «Полиглотики» придали ребёнку самоуверенности. Дочка выучила много новых слов и выражений, стала разговаривать и напевать на английском. Мы очень рады, что нашли вас! Удачи всем!</span>

                </div>
              </div>

              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/no-avatar-1.png"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">20.05.2021</span>
                  <span class="nameotzyv">Olia Foro <a href="https://vk.com/o.foro" target="_blank">vk.com</a></span><br>

                  <span class="textotzyv">В поисках подходящей онлайн школы английского языка для мы перепробовали огромное количество различных школ, но у ребенка пропадал интерес после нескольких уроков. Но попав в эту школу, мы остаёмся тут на долго. Прекрасные преподаватели, которые умеют увлечь маленьких непосед, служба поддержки, которая всегда на связи и оперативно отвечает на все запросы, огромное количество различных занятий. Ребенок с нетерпением ждет каждого урока, всегда есть обратная связь, групповые занятия проходят очень весело и продуктивно. Всегда учитываются пожелания клиента. Очень рады быть с Вами!!!</span>

                </div>
              </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                                     src="@/assets/hometeacher/images/vera-kondrateva.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">18.05.2021</span>
                  <span class="nameotzyv">Вера Кондратьева <a href="https://www.facebook.com/profile.php?id=100008304612517" target="_blank">facebook.com</a></span><br>

                  <span class="textotzyv">Дорогие мамочки обучающие своих детей иностранным языкам с молодых ногтей, ЭТО ТОЧНО ДЛЯ ВАС. Мы нашли замечательную платформу https://poliglotiki.com для изучения англ языка.<br>
                      Уроки проходят с понедельника по субботу 2 раза в день, группы представлены разные от 3 до 17 лет, причем мы живем в Доминикане и по нашему часовому поясу занятия также проходят в 10,11.12,13 по местному, т.е. вечером по Москве. Занятия классные, в игровой форме, для начинающих деток проходит обучение в форме игры, занятий по рисованию, чтение сказок, поем песенки и ВСЕ на англ. Для нас это выход, ребенок общается с другими детьми, постоянно слушает англ речь. Цены не просто доступные, а супердоступные. Первые 3 дня бесплатно, смотрите, пробуете. Мы намучались выбирая разные платформы и способы обучения, многие просто берут неадекватные деньги за те же самые услуги, устраивает все от качества,формы преподования, до цены и внеурочного общения с менеджерами. Это лучшая платформа, что мы встречали по изучению англ языка, там есть и другие языки, но мы пока учим англ. Хотела поделиться с теми, кто также как мы давно ищет нечто подобное и не может найти, я как мать двоих детей, обучающая своих детей дома, понимаю и знаю как это тяжело, поэтому решила сделать здесь пост, кому то надеюсь очень поможет, а вы когда нибудь поделитесь тоже чем то интересным и так общими усилиями будем помогать друг друг в этом нелегком дете воспитания наших деток. Я не менеджер ответов на вопросы не даю, если есть вопросы пишите им лично, сайт я указала. Всем хорошего дня!!</span>

                </div>
              </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                                     src="@/assets/hometeacher/images/elena-serebryakova.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">27.02.2021</span>
                  <span class="nameotzyv">Елена Серебрякова <a href="https://vk.com/id426090428" target="_blank"
                                                               rel="nofollow">vk.com</a></span><br>

                  <span class="textotzyv">Ребенок занимается несколько раз в неделю. Преподаватели все интересные, даже есть носители языка со знанием русского. Дети всегда могут обратиться и на русском, и на английском языках. В занятиях красочные задания, песни; преподаватели всегда интересуются качеством связи, чтобы слышать всех учеников. Поправляют ошибки вежливо, без придирок, всегда обращают внимание на правильность произношения. Занятий много в расписании, можно посещать любые. Преподаватели знакомятся с каждым ребенком, нет чувства, что занимаешься с чужим человеком. К каждой теме, есть тематическая песня. На музыкальных занятиях изучают песни, по строчкам проговаривая текст.</span>
                </div>
              </div>

              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                                     src="@/assets/hometeacher/images/marina-fedorina.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">22.01.2021</span>
                  <span class="nameotzyv">Марина Федорина <a href="https://vk.com/id42068522" target="_blank"
                                                             rel="nofollow">vk.com</a></span><br>

                  <span class="textotzyv">Всем доброго дня! Хочу рассказать об онлайн курсах английского языка от  #полиглотиков.<br>
                    Старший сын учится в третьем классе, второй год изучает английский. Пошёл Миша в сентябре в школу, а учитель английского заболела, а потом и мы все заболели. Начала я искать, где можно английский подтянуть. Все заведения по дополнительному образованию в городе закрыты из-за карантина. Наткнулась на #полиглотиков, там как раз была акция 2 недели бесплатного обучения с онлайн учителем по зуму. Решили попробовать, вроде, понравилось. Миша «ходит» в группу для младших школьников. Вначале слова учили по темам, сейчас грамматика пошла. Втянулся, раньше спрашивал, когда занятия, сейчас сам уже всё расписание выучил, лучше меня знает. В школе тоже пятёрки «пошли» по английскому.<br>
                    Среднего из садика тоже на карантин «высадили», кружки все на дистанционном обучении, только задания присылают. А когда с ним все занятия выполнять… Хотелось, чтобы сам иногда занимался. Решили с Максимом тоже английский начать учить. Записала его в группу для начинающих возраст 5-6 лет. И не пожалела. Сейчас, через 3 месяца уже отвечает на вопросы о себе, о семье может немного рассказать, цвета знает и счёт до 10. Хотя до этого вообще английский не учил. Нравится, как преподаватель с ними работает, слова наглядно на картинках плюс подписаны на английском идёт зрительное и слуховое запоминание. Песенку в начале каждого занятия поют, уже вся семья выучила) Игры разнообразные на закрепление слов. У Максима азарт такой во время игры, первый раз даже не поняла, почему он у меня там кричит во время занятия.<br>
                    Единственное, мне кажется, Максиму не хватает начальных знаний, типа изучение алфавита. И время не всегда удобное, у нас 2 часа разница с московским, занятия иногда в 9 вечера. На курсе 2 варианта занятия днём в 12-13 и вечером в 8-9 вечера. Когда сидим дома, занимаемся днём, когда в садик ходим, то вечером. Хотя что Миша, что Максим готовы на все занятия ходить… и днём и вечером.<br>
                    Программа, в которой проходят занятия простая. 6-летний сын сам разобрался, что где включать.<br>
                    Учителя замечательные, хвалят, подбадривают, стараются всем внимания уделить. В дневных группах мало народа, иногда 1-2 человека занимаются, получается индивидуальное занятие, в вечерних больше — по 6-8 в среднем. В общем, всем, кто хочет поднятуть ребёнка по английскому, или начать изучать очень советую онлайн-курс от #полиглотиков «OnlineTeacher».<br>
                    Ах, да, ещё кроме основных занятий есть дополнительные «Арт класс», «мьюзик класс» и «стори тайм», где дети мастерят, рисуют, поют песни и слушают истории. Занятия проходят легко и весело. Спасибо всем преподавателям школы #полиглотиков.</span>
                </div>
              </div>
            </div>
        </div>
        <Entry/>

    </div>
</template>
<script>

    import Entry from "./Entry";
    import TimetableStatic from "./TimetableStatic";
    import CourseStatic from "./CourseStatic";

    export default {
        components: {
            CourseStatic,
            TimetableStatic,
            Entry,
        },
        name: 'PreschoolEnglish2',

        data: function () {
            return {
                title: null,
            }
        },

        metaInfo() {
            return {
                title: 'Цикл групповых онлайн-занятий по программе Preschool English 2',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: '☝☝☝☝☝ «OnlineTeacher» – это домашний педагог, для встречи с которым не нужно никуда идти!'
                    }
                ]
            }
        },

        mounted() {
        },

        methods: {}
    };
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>
<style lang="scss" scoped>
    .razuchim {
        background-image: url(~@/assets/hometeacher/images/razuchim.png);
        height: 458px;
        background-position: top;
        background-repeat: no-repeat;
        margin-top: -2px;
        margin-bottom: 40px;
    }

    .skill-wrapper {
        position: relative;
    }

    .skill-text {
        font-family: Manrope Bold;
        font-size: 18px;
        line-height: 18px;
        border: 3px solid;
        border-radius: 50%;
        position: absolute;
        text-align: center;
        padding-left: 20px;
        padding-right: 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-line-pack: center;
        align-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .skill-text span {
        margin: auto 0;
    }

    .skill-text-1 {
        color: #b01ced;
        border-color: #b01ced;
        height: 180px;
        width: 180px;
        left: 153px;
        top: 44px;
    }

    .skill-text-2 {
        color: #00b4f1;
        border-color: #00b4f1;
        height: 120px;
        width: 120px;
        top: 185px;
        left: 328px;
    }

    .skill-text-3 {
        color: #00963f;
        border-color: #00963f;
        height: 150px;
        width: 150px;
        top: 284px;
        left: 167px;
    }

    .skill-text-4 {
        color: #33c416;
        border-color: #33c416;
        height: 150px;
        width: 150px;
        top: 1px;
        left: 598px;
    }

    .skill-text-5 {
        color: #fa8500;
        border-color: #fa8500;
        height: 120px;
        width: 120px;
        top: 198px;
        left: 628px;
    }

    .skill-text-6 {
        color: #0450c3;
        border-color: #0450c3;
        height: 180px;
        width: 180px;
        top: 65px;
        left: 767px;
    }

    .skill-text-7 {
        color: #ed1c24;
        border-color: #ed1c24;
        height: 150px;
        width: 150px;
        top: 275px;
        left: 770px;
    }

    .skill-text-8 {
        color: #ed1c24;
        border-color: #ed1c24;
        height: 150px;
        width: 150px;
        top: -5px;
        left: 329px;
    }

    .vidos {
        width: 100%;
        height: 623px;
    }

    .sertifikat {
        max-width: 160px;
    }

    .px18 {
        color: #000;
    }

    .land-t-h2 {
        font-size: 24px;
        color: #4f4d5c;
    }

    .centers-text {
        text-align: center;
    }

    .teacher-krug {
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 2px 5px 3px #0003;
    }

    .teacher-name {
        margin-top: 36px;
        margin-bottom: 15px;
    }

    .teacher-name a {
        font-family: Manrope Bold;
        font-size: 16px;
        color: #000000;
        text-decoration: underline;
    }

    .teacher-name a:hover {
        text-decoration: none;
        color: #5ab947;
    }

    .speach {
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 50px;
        color: #000;
    }

    .bird-pres {
        margin-top: 50px;
        min-height: 200px;
    }

    .bird-pres p {
        font-size: 18px;
        font-family: "Manrope Bold";
        padding-left: 110px;
        color: #000000;
    }

    .bird-pres img {
        float: left;
        margin-right: 10px;
        margin-bottom: 25px;
    }

    .knpk {
        border-radius: 7px;
        font-family: Manrope Bold;
        background: -webkit-gradient(linear, left bottom, left top, from(#058bca), to(#00bdfd));
        /*background: #00bcfb;*/
        font-size: 18px;
        color: #fff;
        padding: 15px 30px;
        box-shadow: 0px 3px 3px #0003;
        text-decoration: none;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    }

    .knpk:hover {
        color: #fff;
        background: #058bca;
    }

    .dateotzyv, .nameotzyv, .textotzyv {
        color: #000;
    }


    @media (max-width: 1024px) {
        .skill-text-1 {
            left: 107px;
        }
        .skill-text-2 {
            left: 266px;
        }
        .skill-text-8 {
            display: none;
        }
        .vidos {
            height: 525px !important;
        }
    }

    @media (max-width: 960px) {
        .skill-text-1 {
            left: 0px;
        }
        .skill-text-2 {
            left: 135px;
        }
        .skill-text-3 {
            left: 0px;
        }
        .skill-text-4 {
            left: 390px;
        }
        .skill-text-5 {
            left: 400px;
        }
        .skill-text-6 {
            left: 530px;
        }
        .skill-text-7 {
            left: 525px;
        }
        .vidos {
            height: 390px !important;
        }
    }

    @media (max-width: 640px) {
        .razuchim {
            background-image: url(~@/assets/hometeacher/images/skills-boy.png);
            margin-bottom: 0px;
        }
        .skill-text-1 {
            width: 150px;
            height: 150px;
            top: 0px !important;
            left: 40px !important;
        }
        .skill-text-2 {
            left: 20px !important;
            top: 125px !important;
        }
        .skill-text-3 {
            left: 33px !important;
            top: 215px !important;
        }
        .skill-text-4 {
            left: 328px !important;
            width: 140px;
            height: 140px;
            top: 0px !important;
        }
        .skill-text-5 {
            left: 300px !important;
        }
        .skill-text-6 {
            left: 358px !important;
            width: 130px;
            height: 130px;
            top: 108px !important;
        }
        .skill-text-7 {
            left: 165px !important;
            top: 230px !important;
        }
        .vidos {
            height: 287px !important;
        }
    }

    @media (max-width: 481px) {
        .skill-text-1 {
            left: 20px !important;
        }
        .skill-text-4 {
            left: 295px !important;
        }
        .skill-text-6 {
            left: 315px !important;
        }
        .skill-text-5 {
            top: 230px !important;
        }
        .vidos {
            height: 258px !important;
        }
    }

    @media (max-width: 400px) {
        .skill-text-1 {
            width: 120px;
            height: 120px;
            left: 15px !important;
        }
        .skill-text-2 {
            top: 108px !important;
        }
        .skill-text-3 {
            left: 19px !important;
            width: 130px;
            height: 130px;
        }
        .skill-text-4 {
            width: 125px;
            height: 125px;
            left: 243px !important;
        }
        .skill-text-5 {
            left: 240px !important;
        }
        .skill-text-6 {
            width: 120px;
            height: 120px;
            left: 243px !important;
        }
        .skill-text-7 {
            width: 130px;
            height: 130px;
            left: 140px !important;
        }
        .vidos {
            height: 214px !important;
        }
    }

    @media (max-width: 375px) {
        .vidos {
            height: 202px !important;
        }
    }

    @media (max-width: 320px) {
        .vidos {
            height: 180px !important;
        }
        .skill-text-4 {
            left: 194px !important;
        }
        .skill-text-6 {
            left: 193px !important;
        }
        .skill-text-7 {
            left: 113px !important;
        }
        .skill-text-5 {
            left: 200px !important;
        }
        .skill-text-1, .skill-text-2, .skill-text-3 {
            left: 0px !important;
        }
    }

    @media (max-width: 991px) {
        .skill-text-1 {
            left: 0px;
            top: 0px;
        }
        .skill-text-2 {
            left: 190px;
            top: 0px;
        }
        .skill-text-3 {
            left: 375px;
            top: 0px;
        }
        .skill-text-4 {
            left: 485px;
            top: 110px;
        }
        .skill-text-5 {
            left: 50px;
            top: 170px;
        }
        .skill-text-6 {
            left: 450px;
            top: 250px;
        }
        .skill-text-7 {
            left: 50px;
        }
        .skill-text-8 {
            left: 500px;
            top: 335px;
        }
    }

    @media (max-width: 767px) {
        .skill-text-3 {
            left: 310px;
        }
        .skill-text-4 {
            left: 335px;
            top: 290px;
        }
        .skill-text-6 {
            left: 335px;
            top: 155px;
        }
        .skill-text-7 {
            left: 0px;
            top: 300px;
        }

    }

    @media (max-width: 575px) {
        .blue-wave-top, .blue-wave-bottom, .green-wave-bottom, .green-wave-top {
            background-size: auto;
        }
        .topchik h1 {
            margin-left: 15px;
        }
        .group {
            float: none;
            margin-left: 15px;
        }
        .prezent {
            text-align: center;
        }
        .prezent h2 {
            margin-left: 15px;
            margin-right: 15px;
            text-align: left;
        }
        .prezent h3 {
            margin-left: 15px;
            margin-right: 15px;
            text-align: left;
        }
        .prezent p {
            text-align: left;
        }
        .prezent img {
            float: none;
            margin-left: 15px;
            margin-top: 15px;
            margin-bottom: 30px;
        }
        .orange-knp {
            padding: 20px 30px;
        }
        .white-bg h2 {
            margin-left: 15px;
        }
        .nazan {
            margin-left: 0px;
        }
        .skill-wrapper img {
            width: 133px;
            margin-left: 0px;
            margin-top: 264px;
        }
        .urok {
            height: 755px;
        }
        .skill-text-4 {
            left: 47%;
            top: 0px;
        }
        .skill-text-2 {
            left: 3%;
            top: 150px;
        }
        .skill-text-7 {
            width: 130px;
            height: 130px;
            left: 10px;
            top: 300px;
        }
        .skill-text-3 {
            left: 49%;
            top: 180px;
        }
        .skill-text-7 {
            left: 49%;
            top: 535px;
        }
        .skill-text-5 {
            left: 28px;
            top: 215px;
        }
        .skill-text-8 {
            top: 635px;
            left: 50px;
        }
        .skill-text-6 {
            left: 62%;
            top: 375px;
        }
        .mbpt {
            padding-bottom: 10px !important;
        }
        .vidos {
            height: 311px;
            margin-left: 2px;
        }
        .speach {
            margin-left: 10px;
            margin-right: 10px;
        }

    }

</style>
